import { render, staticRenderFns } from "./YandexMarket.vue?vue&type=template&id=4ea32a8a&"
import script from "./YandexMarket.vue?vue&type=script&lang=js&"
export * from "./YandexMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports